import { Outlet } from 'react-router';

import { getRoutesFromFiles } from '@sorare/routing';
import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import { Dialog } from '@sorare/core/src/components/dialog';
import {
  DialogKey,
  WithDialogs,
} from '@sorare/core/src/components/navigation/WithDialogs';
import { SportSwitcher } from '@sorare/core/src/contexts/sport/SportSwitcher';
import { lazy } from '@sorare/core/src/lib/retry';
import { usePackOpeningInterruptedSnackbar } from '@sorare/gameplay/src/hooks/usePackOpeningInterruptedSnackbar';

/*
 * Prefer dynamic over static import into this file
 * because static ones will end up in the main bundle
 */
const BundledAuctionPage = lazy(
  async () => import('#src/components/auction/BundledAuctionPage/index.tsx'),
  'BundledAuctionPage'
);

const StandaloneMatchViewDialog = lazy(
  async () =>
    import('@sorare/gameplay/src/components/stats/StandaloneMatchViewDialog'),
  'StandaloneMatchViewDialog'
);

const So5LeaderboardContenderDialogFromParams = lazy(
  async () =>
    import('#src/components/lineup/So5LeaderboardContenderDialogFromParams/index.tsx'),
  'So5LeaderboardContenderDialogFromParams'
);

const FootballLayout = () => {
  usePackOpeningInterruptedSnackbar();
  return (
    <WithDialogs
      dialogs={[
        {
          name: DialogKey.bundledAuction,
          element: (
            <Dialog open fullScreen>
              <BundledAuctionPage />
            </Dialog>
          ),
        },
        {
          name: DialogKey.game,
          element: <StandaloneMatchViewDialog />,
        },
        {
          name: DialogKey.contender,
          element: <So5LeaderboardContenderDialogFromParams />,
        },
      ]}
    >
      <SportSwitcher sport={Sport.FOOTBALL} />
      <Outlet />
    </WithDialogs>
  );
};

const gamePlayFiles = Object.fromEntries(
  Object.entries(
    import.meta.glob('../../../gameplay/src/pages/**/(page|layout).tsx')
  ).map(([key, value]) => [
    key.replace('../../../gameplay/src/pages/', './'),
    value,
  ])
);

export const routeObjects = [
  {
    element: <FootballLayout />,
    children: [
      ...getRoutesFromFiles(
        { ...gamePlayFiles, ...import.meta.glob('./**/(page|layout).tsx') },
        '../../packages/football/src/pages'
      ),
    ],
  },
];
